import { observer } from 'mobx-react';
import * as React from 'react';
import DragIndicatorIcon from '../../../../../Cutesies/DragIndicatorIcon';
import TableHead from './TableHead';
import { ModifiableExperiencesContext } from '../../../Types';
import LearningCollectionEditStore from '../../../Edit/Store';

interface Props {
  context: ModifiableExperiencesContext;
  store: LearningCollectionEditStore;
}

const TableHeadWithHandlers: React.FC<Props> = ({ context, store }) => {
  return (
    <>
      <th className="bg-gray-50 px-3 py-4">
        <input
          className="h-5 w-4 cursor-pointer text-teal-600"
          type="checkbox"
          name="modifyExperience"
          checked={store.allExperiencesSelected(context)}
          onChange={() => store.toggleAllExperienceStores(context)}
          aria-label="Select all experiences"
        />
      </th>
      <th className="bg-gray-50 px-3 py-4 text-left text-xs font-semibold">
        <DragIndicatorIcon />
      </th>
      <TableHead />
    </>
  );
};

export default observer(TableHeadWithHandlers);
